import { Component } from '@angular/core';

@Component({
    selector: 'app-wm-personalized-dashboard',
    standalone: true,
    templateUrl: './wm-personalized-dashboard.component.html',
})
export class WmPersonalizedDashboardComponent {}
